<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation></navigation>
    </div>
    <!--中间主体-->
    <div class="new_content">
      <div class="new_jpkc_erji">
        <div class="new_webposition">
          <el-breadcrumb separator="/" class="nje_last">
            <el-breadcrumb-item style="float: none">资讯列表</el-breadcrumb-item>
            <el-breadcrumb-item style="float: none">{{consultName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="new_jpkc_list" id="kc">
          <div class="njl1"v-for="item in newsList">
            <div class="njl_pic"><router-link :to="{ path: 'newsInfo', query: { id: item.id }}" target="_blank"><img :src="item.image" /></router-link></div>
            <router-link :to="{ path: 'newsInfo', query: { id: item.id }}" target="_blank" class="njl_text">
              <span class="njl_title textover">{{item.newsTitle}}</span>
              <span class="njl_intro">{{item.description}}</span>
              <span class="njl_speaker">{{item.publishTime}}</span>
            </router-link>
          </div>
        </div>
        <div class="new_num_list" id="coursePageUl">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {listNews} from '../api/api';
  import  header2 from '../components/Header2'
  import  footer1 from '../components/Footer1'
  import  navigation from '../components/Navigation'
  export default {
    components: {
      header2,
      navigation,
      footer1
    },
    data () {
      return {
        newsList: [],
        consultName: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    },
    mounted () {
      this.initD();
    },
    computed: {
      conversionProjectIdsC() {
          let projectIdsC = this.$route.query.projectIdsC;
          if(projectIdsC&&projectIdsC.length>0){
              if(projectIdsC instanceof Array){
                  return projectIdsC;
              }else{
                  return new Array(this.$route.query.projectIdsC);
              }
          }else{
              return []
          }
      }
    },
    methods: {
      initD(){
        listNews({
          parentTagId:this.$route.query.parentTagId,
          tagId:this.$route.query.tagId,
          consultId: this.$route.query.consultId,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'displayPositionIds': [1, 3],
          'notProjectIds': [8, 9],
          'projectIdsC': this.conversionProjectIdsC,
          'orderWeight': true,
          orderPublishTime: true,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((response) => {
          this.newsList = response.data.data.list;
          this.consultName = response.data.data.consultName;
          this.total = response.data.data.total;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.initD();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.initD();
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/NewsMore.vue